export const restauranteFeatureFlags = {
  layoutVisual: true,
  kdsAvancado: true,
  qrMesa: false,
  deliveryUnificado: false,
  nfceCheckout: true,
};

export const restauranteTempoLimites = {
  producaoAtencaoMinutos: 12,
  producaoAtrasoMinutos: 20,
  mesaAtencaoMinutos: 45,
};
